import React, { useState, useEffect } from "react";
import { Row, Col, Image } from "react-bootstrap";
import Axios from "axios";

//STYLES
import * as FourSectionsOneRowStyles from "./styles";

function FourSectionsOneRow() {
    const [data, setData] = useState([
        {
            image: "",
            text: "",
            backgroundColor: ""
        },
        {
            image: "",
            text: "",
            backgroundColor: ""
        },
        {
            image: "",
            text: "",
            backgroundColor: ""
        },
        {
            image: "",
            text: "",
            backgroundColor: ""
        }
    ]);

    useEffect(() => {
        Axios.post("/style/fourSectionsOneRow/load")
            .then((res) => {
                const respondData = res.data;
                if (respondData.error == "null") {
                    const newData = { ...data };
                    newData[0].image = respondData.info.section1Image;
                    newData[0].text = respondData.info.section1Text;
                    newData[1].image = respondData.info.section2Image;
                    newData[1].text = respondData.info.section2Text;
                    newData[2].image = respondData.info.section3Image;
                    newData[2].text = respondData.info.section3Text;
                    newData[3].image = respondData.info.section4Image;
                    newData[3].text = respondData.info.section4Text;
                    setData(newData);
                }
            })
            .catch((err) => console.log(err));
    }, []);

    function handleOnMouseEnter(id) {
        const section = { ...data[id] };

        section.backgroundColor = "rgba(255, 0, 0, 0.3)";

        setData((prevState) => {
            return { ...prevState, [id]: section };
        });
    }

    function handleOnMouseLeave(id) {
        const section = { ...data[id] };
        console.log("over");

        section.backgroundColor = "";

        setData((prevState) => {
            return { ...prevState, [id]: section };
        });
    }

    return (
        <div>
            <Row>
                <Col style={FourSectionsOneRowStyles.column}>
                    <div
                        style={{ ...FourSectionsOneRowStyles.section, backgroundColor: data[0].backgroundColor }}
                        onMouseEnter={handleOnMouseEnter.bind(this, 0)}
                        onMouseLeave={handleOnMouseLeave.bind(this, 0)}
                    >
                        <div style={FourSectionsOneRowStyles.imageContainer}>
                            <Image src={`/content/mainStyle/fourSectionsOneRow/${data[0].image}`} style={FourSectionsOneRowStyles.image} />
                        </div>
                        <div style={FourSectionsOneRowStyles.textContainer}>{data[0].text}</div>
                    </div>
                </Col>
                <Col style={FourSectionsOneRowStyles.column}>
                    <div
                        style={{ ...FourSectionsOneRowStyles.section, backgroundColor: data[1].backgroundColor }}
                        onMouseEnter={handleOnMouseEnter.bind(this, 1)}
                        onMouseLeave={handleOnMouseLeave.bind(this, 1)}
                    >
                        <div style={FourSectionsOneRowStyles.imageContainer}>
                            <Image src={`/content/mainStyle/fourSectionsOneRow/${data[1].image}`} style={FourSectionsOneRowStyles.image} />
                        </div>
                        <div style={FourSectionsOneRowStyles.textContainer}>{data[1].text}</div>
                    </div>
                </Col>
                <Col style={FourSectionsOneRowStyles.column}>
                    <div
                        style={{ ...FourSectionsOneRowStyles.section, backgroundColor: data[2].backgroundColor }}
                        onMouseEnter={handleOnMouseEnter.bind(this, 2)}
                        onMouseLeave={handleOnMouseLeave.bind(this, 2)}
                    >
                        <div style={FourSectionsOneRowStyles.imageContainer}>
                            <Image src={`/content/mainStyle/fourSectionsOneRow/${data[2].image}`} style={FourSectionsOneRowStyles.image} />
                        </div>
                        <div style={FourSectionsOneRowStyles.textContainer}>{data[2].text}</div>
                    </div>
                </Col>
                <Col style={FourSectionsOneRowStyles.column}>
                    <div
                        style={{ ...FourSectionsOneRowStyles.section, backgroundColor: data[3].backgroundColor }}
                        onMouseEnter={handleOnMouseEnter.bind(this, 3)}
                        onMouseLeave={handleOnMouseLeave.bind(this, 3)}
                    >
                        <div style={FourSectionsOneRowStyles.imageContainer}>
                            <Image src={`/content/mainStyle/fourSectionsOneRow/${data[3].image}`} style={FourSectionsOneRowStyles.image} />
                        </div>
                        <div style={FourSectionsOneRowStyles.textContainer}>{data[3].text}</div>
                    </div>
                </Col>
            </Row>
        </div>
    );
}

export default FourSectionsOneRow;
